import styled from 'styled-components';
import { CALYPSO_LIGHT, LORAX, EERIE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import UIIconButton from 'UIComponents/button/UIIconButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReplyRecContainer = styled.aside.withConfig({
  displayName: "ReplyRecommendation__ReplyRecContainer",
  componentId: "q01n8o-0"
})(["background-color:", ";padding:8px;"], CALYPSO_LIGHT);
const ReplyRecHeader = styled.div.withConfig({
  displayName: "ReplyRecommendation__ReplyRecHeader",
  componentId: "q01n8o-1"
})(["display:flex;justify-content:space-between;margin-bottom:8px;"]);
const ReplyRecAIIcon = styled(UIIcon).withConfig({
  displayName: "ReplyRecommendation__ReplyRecAIIcon",
  componentId: "q01n8o-2"
})(["padding-right:6px;"]);
const ReplyRecUIButton = styled(UIButton).withConfig({
  displayName: "ReplyRecommendation__ReplyRecUIButton",
  componentId: "q01n8o-3"
})(["&&&{margin:0px;}"]);
const ReplyRecUIIconButton = styled(UIIconButton).withConfig({
  displayName: "ReplyRecommendation__ReplyRecUIIconButton",
  componentId: "q01n8o-4"
})(["&&&{margin:0px;}"]);
const ReplyRecIconTitle = styled.div.withConfig({
  displayName: "ReplyRecommendation__ReplyRecIconTitle",
  componentId: "q01n8o-5"
})(["display:flex;align-items:center;"]);
const ReplyRecTitle = styled.h2.withConfig({
  displayName: "ReplyRecommendation__ReplyRecTitle",
  componentId: "q01n8o-6"
})(["font-weight:bold;font-size:12px;margin:0px;"]);
const ReplyRecButtonContainer = styled.div.withConfig({
  displayName: "ReplyRecommendation__ReplyRecButtonContainer",
  componentId: "q01n8o-7"
})(["display:flex;gap:8px;"]);
const ReplyRecBody = styled.div.withConfig({
  displayName: "ReplyRecommendation__ReplyRecBody",
  componentId: "q01n8o-8"
})(["max-height:58px;overflow:auto;"]);
export const ReplyRecommendation = props => {
  const {
    shouldDisableSubmit,
    disableSubmitMessage,
    onSend,
    onEdit,
    onIgnore,
    recBody,
    track
  } = props;
  useEffect(() => {
    if (track) track();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsxs(ReplyRecContainer, {
    role: "status",
    children: [/*#__PURE__*/_jsxs(ReplyRecHeader, {
      children: [/*#__PURE__*/_jsxs(ReplyRecIconTitle, {
        children: [/*#__PURE__*/_jsx(ReplyRecAIIcon, {
          name: "artificialIntelligenceEnhanced",
          color: LORAX
        }), /*#__PURE__*/_jsx(ReplyRecTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.reply-recommendations.title"
          })
        })]
      }), /*#__PURE__*/_jsxs(ReplyRecButtonContainer, {
        children: [/*#__PURE__*/_jsxs(ReplyRecUIButton, {
          size: "extra-small",
          use: "tertiary-light",
          onClick: onEdit,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "edit"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.reply-recommendations.edit"
          })]
        }), /*#__PURE__*/_jsx(UITooltip, {
          disabled: !shouldDisableSubmit,
          title: disableSubmitMessage,
          children: /*#__PURE__*/_jsxs(ReplyRecUIButton, {
            size: "extra-small",
            use: "tertiary",
            disabled: shouldDisableSubmit,
            onClick: onSend,
            children: [/*#__PURE__*/_jsx(UIIcon, {
              name: "send"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "composer-ui.reply-recommendations.send"
            })]
          })
        }), /*#__PURE__*/_jsx(ReplyRecUIIconButton, {
          use: "transparent",
          size: "extra-small",
          onClick: onIgnore,
          "aria-label": I18n.text('composer-ui.reply-recommendations.ignore'),
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "remove",
            color: EERIE
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(ReplyRecBody, {
      children: recBody
    })]
  });
};
ReplyRecommendation.displayName = 'ReplyRecommendation';